module.exports = __webpack_public_path__ + "static/media/next-page.3c7b4e4c.svg";